import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Lock } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@/components/ui/empty";
import type { PlanFeature } from "../../types/billing";
import { FEATURE_COPY } from "../../utils/planAccess";

/** Holding screen for an area the user's plan doesn't include (Free). Same empty-state look as Statistics. */
export default function PlanLockedScreen({ feature }: { feature: PlanFeature }) {
  const copy = FEATURE_COPY[feature];
  return (
    <div data-plan-locked-screen={feature} className="flex min-h-[60vh] w-full flex-1 flex-col items-center justify-center px-6">
      <Empty className="w-full max-w-lg min-h-[280px] border-0 bg-transparent py-10 shadow-none">
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <Lock size={16} className="text-gray-500 dark:text-white" aria-hidden />
          </EmptyMedia>
          <EmptyTitle className="font-[family-name:var(--font-primary)] text-base font-normal text-[color:var(--brand-tropical-surf)]">
            {copy.title} is on the paid plans
          </EmptyTitle>
          <EmptyDescription className="font-[family-name:var(--font-primary)] font-normal text-gray-500 dark:text-white">
            {copy.body} Available on Standard, Plus and Pro.
          </EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button asChild variant="outline-brand" size="sm" data-font="primary" className="shadow-none">
            <RouterLink to="/profile/billing" data-plan-locked-upgrade="">
              <span className="normal-case tracking-normal">See plans</span>
            </RouterLink>
          </Button>
        </EmptyContent>
      </Empty>
    </div>
  );
}
